<template>
  <div class="restaurantAttendance">
    <div class="title">
      <div>{{$route.meta.title}}</div>
      <input type="radio" v-model="page" value="出勤紀錄">
      <input type="radio" v-model="page" value="出勤結算">
      <!-- <Select :defaultValue="store" @input="$router.replace({ name: $route.name, query: { store: $event } })" :width="'360px'" :style="{marginLeft: 'auto'}">
        <option :key="`rest-${r}`" :value="rest" v-for="(rest, r) in restaurants">{{rest}}</option>
      </Select> -->
    </div>
    <div class="content" v-if="page==='出勤紀錄'">
      <div>
        <div class="weekcelender-top">
          <button @click="addWeek(-1)">
            <svg width="11" height="25" viewBox="0 0 11 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 1.32828C11 1.59793 10.917 1.872 10.742 2.10629L3.78769 11.5264C3.35697 12.1077 3.35697 12.8923 3.78769 13.4736L10.742 22.8937C11.1795 23.4861 11.0471 24.3149 10.4459 24.7459C9.84468 25.1769 9.00343 25.0465 8.56598 24.4541L1.61166 15.0341C0.492239 13.5178 0.492239 11.4822 1.61166 9.96595L8.56598 0.545849C9.00343 -0.0464977 9.84468 -0.176903 10.4459 0.254097C10.8071 0.512695 11 0.917171 11 1.32828Z" fill="var(--color-checked)"/>
            </svg>
          </button>
          <div>{{moment(start).format('yyyy')}},{{moment(start).format('M/D')}}~{{moment(start).add(6, 'day').format('M/D')}}</div>
          <button @click="addWeek(1)">
            <svg width="11" height="25" viewBox="0 0 11 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.68732e-06 23.6717C4.69911e-06 23.4021 0.0830087 23.128 0.257988 22.8937L7.21231 13.4736C7.64303 12.8923 7.64303 12.1077 7.21231 11.5264L0.257989 2.10629C-0.179461 1.51394 -0.0471039 0.685096 0.554109 0.254097C1.15532 -0.176902 1.99657 -0.046497 2.43402 0.545851L9.38834 9.96595C10.5078 11.4822 10.5078 13.5178 9.38834 15.0341L2.43402 24.4542C1.99657 25.0465 1.15532 25.1769 0.554108 24.7459C0.192931 24.4873 4.66935e-06 24.0828 4.68732e-06 23.6717Z" fill="var(--color-checked)"/>
            </svg>
          </button>
        </div>
        <div class="weekcelender-content">
          <div v-for="d in 7" :key="d" :class="moment(start).add(d-1, 'day').format('yyyy/MM/DD')===moment(day).format('yyyy/MM/DD')?'current':''"
          @click="day=moment(start).add(d-1, 'day')">
            <div>({{wdy[moment(start).add(d-1, 'day').weekday()]}})</div>
            <div>
              <div>{{moment(start).add(d-1, 'day').format('M/D')}}</div>
              <div>{{days[d-1] ? days[d-1].total : 0}}</div>
            </div>
            <div class="num-summary" v-if="days[d-1]">
              <!-- Object.values(days[d-1].attendance) -->
              <div label="內場">{{Array.from(new Set([].concat(...Object.values(days[d-1].attendance).filter(e => e).map(e => e.back)).map(e=>e._id))).length}}</div>
              <div label="外場">{{Array.from(new Set([].concat(...Object.values(days[d-1].attendance).filter(e => e).map(e => e.front)).map(e=>e._id))).length}}</div>
              <div label="內PT">{{Array.from(new Set([].concat(...Object.values(days[d-1].attendance).filter(e => e).map(e => e.backPT)).map(e=>e._id))).length}}</div>
              <div label="外PT">{{Array.from(new Set([].concat(...Object.values(days[d-1].attendance).filter(e => e).map(e => e.frontPT)).map(e=>e._id))).length}}</div>
            </div>
          </div>
        </div>
        <div class="day-content" :style="{marginTop: '18px'}">
          <div class="day-content-top">{{moment(day).format('M/D')}}({{wdy[moment(day).weekday()]}})
            <button @click="preedit='pre'">排班</button>
          </div>
          <template v-if="current">
            <div class="day-content-li" v-for="(time, i) in Object.keys(current.number)" :key="`current-${i}`">
              <div>{{time}}<br><span :style="{fontWeight: '900', fontSize: '14px'}">({{current.number[time].map(e=>e.count).reduce((a, b) => a + b, 0)}})</span></div>
              <div class="day-num-summary" label="內場">{{current.attendance[time] ? current.attendance[time].back.length : 0}}</div>
              <div class="day-num-summary" label="外場">{{current.attendance[time] ? current.attendance[time].front.length : 0}}</div>
              <div class="day-num-summary" label="內PT">{{current.attendance[time] ? current.attendance[time].backPT.length : 0}}</div>
              <div class="day-num-summary" label="外PT">{{current.attendance[time] ? current.attendance[time].frontPT.length : 0}}</div>
            </div>
          </template>
        </div>
      </div>
      <div>
        <div class="day-edit-top">{{moment(day).format('yyyy, M/D')}}({{wdy[moment(day).weekday()]}})
          <button :style="{marginLeft: 'auto'}" @click="reloadData">取消</button>
          <button :style="{backgroundColor: 'var(--color-confirm)'}" @click="apply">套用</button>
        </div>
        <div class="day-edit-li" v-if="current">
          <div v-for="(time, i) in Object.keys(current.number)" :key="`current-large-${i}`">
            <div>{{time}}<br><span :style="{fontWeight: '900', fontSize: '16px'}">({{current.number[time].map(e=>e.count).reduce((a, b) => a + b, 0)}})</span></div>
            <div>
              <div>內場 <button class="addbtn" :style="{marginLeft: 'auto'}" @click="preedit=time;preedit2='back'"></button></div>
              <div class="liststaff"><div v-for="({name}, i) in current.attendance[time].back" :key="`backlist-${i}`">{{name}}<button @click="current.attendance[time].back.splice(i, 1)"></button></div></div>
            </div>
            <div>
              <div>外場 <button class="addbtn" :style="{marginLeft: 'auto'}" @click="preedit=time;preedit2='front'"></button></div>
              <div class="liststaff"><div v-for="({name}, i) in current.attendance[time].front" :key="`backlist-${i}`">{{name}}<button @click="current.attendance[time].front.splice(i, 1)"></button></div></div>
            </div>
            <div>
              <div>內場PT <button class="addbtn" :style="{marginLeft: 'auto'}" @click="preedit=time;preedit2='backPT'"></button></div>
              <div class="liststaff"><div v-for="({name}, i) in current.attendance[time].backPT" :key="`backlist-${i}`">{{name}}<button @click="current.attendance[time].backPT.splice(i, 1)"></button></div></div>
            </div>
            <div>
              <div>外場PT <button class="addbtn" :style="{marginLeft: 'auto'}" @click="preedit=time;preedit2='frontPT'"></button></div>
              <div class="liststaff"><div v-for="({name}, i) in current.attendance[time].frontPT" :key="`backlist-${i}`">{{name}}<button @click="current.attendance[time].frontPT.splice(i, 1)"></button></div></div>
            </div>
          </div>
        </div>
        <dialognoPadding2Vue :style="{position:'absolute', left: 0}" :show="true" class="pre" v-if="preedit==='pre'" :label="`預排班-${moment(day).format('yyyy, M/D')}`" width="880" height="845" @close="clear();preedit=null">
          <div class="day-preedit" :style="{padding: '20px 40px', overflowY: 'auto', maxHeight: '700px'}">
            <div>
              <div>內場 <button class="addbtn" :style="{marginLeft: '20px'}" @click="preedit2='內場'"></button></div>
              <div class="liststaff">
                <div v-for="(us, i) in pre['內場']" :key="`內場-${i}`">
                  <span>{{us.name}}</span><button @click="pre['內場'].splice(i, 1)"></button>
                </div>
              </div>
            </div>
            <div>
              <div>外場 <button class="addbtn" :style="{marginLeft: '20px'}" @click="preedit2='外場'"></button></div>
              <div class="liststaff">
                <div v-for="(us, i) in pre['外場']" :key="`外場-${i}`">
                  <span>{{us.name}}</span><button @click="pre['外場'].splice(i, 1)"></button>
                </div>
              </div>
            </div>
            <div>
              <div>內場PT <button class="addbtn" :style="{marginLeft: '20px'}" @click="preedit2='內場PT'"></button></div>
              <div class="liststaff">
                <div v-for="(us, i) in pre['內場PT']" :key="`內場PT-${i}`">
                  <span>{{us.name}}</span><button @click="pre['內場PT'].splice(i, 1)"></button>
                </div>
              </div>
            </div>
            <div>
              <div>外場PT <button class="addbtn" :style="{marginLeft: '20px'}" @click="preedit2='外場PT'"></button></div>
              <div class="liststaff">
                <div v-for="(us, i) in pre['外場PT']" :key="`外場PT-${i}`">
                  <span>{{us.name}}</span><button @click="pre['外場PT'].splice(i, 1)"></button>
                </div>
              </div>
            </div>
            <div class="btns" :style="{height: '35px', minHeight: '35px', gap: '28px'}">
              <button @click="clear();preedit=null">取消</button>
              <button :style="{backgroundColor: 'var(--color-confirm)'}" @click="save">套用</button>
            </div>
          </div>
        </dialognoPadding2Vue>
        <dialognoPadding2Vue :style="{position:'absolute', left: 0}" :show="true" class="sub" v-if="preedit2&&/PT/i.test(preedit2)" :label="`預排班-${moment(day).format('yyyy, M/D')}-${trans[preedit2]}`" @close="preedit2=null"
        width="699" height="700">
        <div :style="{padding: '20px 40px', display:'flex', flexDirection:'column', gap:'20px', maxHeight: '700px'}">
        <select v-model="department">
          <option v-for="dep in departmentsPT" :key="dep" :value="dep">{{dep}}</option>
        </select>
          <div class="empsbox">
            <label class="checkbox" :for="us._id"  v-for="(us, i) in empsPT.filter(e => !selected.includes(e._id))" :key="`us-${i}`">
            <input type="checkbox" v-model="preSelected" :id="us._id" :value="us">
            {{us.name}}
            </label>
          </div>
          <div class="btns" :style="{margin: 'auto', height: '35px', minHeight: '35px'}">
            <button :style="{backgroundColor: 'var(--color-confirm)'}" @click="addstaff">確認</button>
          </div>
        </div>
        </dialognoPadding2Vue>
        <dialognoPadding2Vue :style="{position:'absolute', left: 0}" :show="true" class="sub" v-if="preedit2&&!/PT/i.test(preedit2)" :label="`預排班-${moment(day).format('yyyy, M/D')}-${trans[preedit2]}${preedit!=='pre' ? ('-'+preedit) : ''}`" @close="preedit2=null"
        width="699" height="700">
        <div :style="{padding: '20px 40px', display:'flex', flexDirection:'column', gap:'20px', maxHeight: '700px'}">
        <select v-model="department">
          <option v-for="dep in departments" :key="dep" :value="dep">{{dep}}</option>
        </select>
          <div class="empsbox" :style="{margin: 'none', padding: 'none'}">
            <label class="checkbox" :for="us._id"  v-for="(us, i) in emps.filter(e => !selected.includes(e._id))" :key="`us-${i}`">
            <input type="checkbox" v-model="preSelected" :id="us._id" :value="us">
            {{us.name}}
            </label>
          </div>
          <div class="btns" :style="{margin: 'auto', height: '35px', minHeight: '35px'}">
            <button :style="{backgroundColor: 'var(--color-confirm)'}" @click="addstaff">確認</button>
          </div>
        </div>
        </dialognoPadding2Vue>
      </div>
    </div>
    <restWorkCelender :restaurantInfo="restaurantInfo" :store="store" v-else/>
  </div>
</template>

<script>
import restWorkCelender from './restWorkerCelender.vue'
import { getapi, postapi, putapi } from '../store/fetch'
// import Select from '../components/select.vue'
import dialognoPadding2Vue from '../components/dialognoPadding2.vue'
import { mapState } from 'vuex'
export default {
  components: {
    dialognoPadding2Vue,
    restWorkCelender
    // ,
    // Select
  },
  data () {
    return {
      page: '出勤紀錄',
      trans: {
        back: '內場',
        front: '外場',
        backPT: '內場PT',
        frontPT: '外場PT',
        內場: '內場',
        外場: '外場',
        內場PT: '內場PT',
        外場PT: '外場PT'
      },
      wdy: ['日', '一', '二', '三', '四', '五', '六'],
      start: this.moment().startOf('week').add(1, 'day'),
      day: this.moment().startOf('day'),
      holidays: [],
      availables: [],
      days: [],
      preedit: false,
      preedit2: null,
      emps: [],
      empsPT: [],
      department: '營運一部',
      departments: [],
      departmentsPT: [],
      preSelected: [],
      pre: {
        內場: [],
        外場: [],
        內場PT: [],
        外場PT: []
      }
    }
  },
  async mounted () {
    this.setDays()
    const departments = await getapi('users/department')
    this.departments = departments.filter(e => e)
    const departmentsPT = await getapi('users/department/PT')
    this.departmentsPT = departmentsPT.filter(e => e)
  },
  computed: {
    store () {
      return this.$route.query?.store || '松柏軒'
    },
    selected () {
      if (this.preedit === 'pre' && this.preedit2 && !/PT/i.test(this.preedit2)) {
        return [...this.pre.內場, ...this.pre.外場].map(e => e._id)
      } else if (this.preedit === 'pre' && this.preedit2 && /PT/i.test(this.preedit2)) {
        return [...this.pre.內場PT, ...this.pre.外場PT].map(e => e._id)
      } else if (this.preedit && this.preedit2 && !/PT/i.test(this.preedit2)) {
        const d = this.current.attendance[this.preedit]
        return [...d.back, ...d.front].map(e => e._id)
      } else if (this.preedit && this.preedit2 && /PT/i.test(this.preedit2)) {
        const d = this.current.attendance[this.preedit]
        return [...d.backPT, ...d.frontPT].map(e => e._id)
      } else {
        return []
      }
    },
    current () {
      if (this.days) {
        const index = this.moment(this.day).diff(this.moment(this.start), 'day')
        console.log('current', index, this.days[index])
        return this.days[index]
      } else {
        return null
      }
    },
    restaurantInfo () {
      return this.restaurantsInfos.find(e => e.name === this.store)
    },
    ...mapState({
      restaurantsInfos: 'restaurantsInfos',
      restaurants: 'restaurants'
    })
  },
  watch: {
    async preedit2 () {
      if (this.preedit2) {
        if (/PT/i.test(this.preedit2)) {
          const users = await getapi(`users/emps/PT?department=${this.department}`)
          this.empsPT = users
        } else {
          const users = await getapi(`users/emps?department=${this.department}`)
          this.emps = users
        }
      }
    },
    async department () {
      if (this.preedit2) {
        if (/PT/i.test(this.preedit2)) {
          const users = await getapi(`users/emps/PT?department=${this.department}`)
          this.empsPT = users
        } else {
          const users = await getapi(`users/emps?department=${this.department}`)
          this.emps = users
        }
      }
    },
    start () {
      this.setDays()
    },
    store () {
      this.setDays()
    }
  },
  methods: {
    async apply () {
      Promise.all(Object.keys(this.current.attendance).map(async (t) => {
        return await postapi('restStatus/restAttendance?' + new URLSearchParams({
          store: this.store,
          day: this.day.toISOString(),
          time: t
        }), {
          back: this.current.attendance[t].back,
          front: this.current.attendance[t].front,
          backPT: this.current.attendance[t].backPT,
          frontPT: this.current.attendance[t].frontPT
        })
      })).then(r => {
        console.log('apply done', r)
        this.reloadData()
      })
    },
    async save () {
      const r = await putapi('restStatus/restAttendance?' + new URLSearchParams({
        store: this.store,
        day: this.day.toISOString(),
        time: [].concat(...Object.keys(this.current.number))
      }), {
        back: this.pre['內場'],
        front: this.pre['外場'],
        backPT: this.pre['內場PT'],
        frontPT: this.pre['外場PT']
      })
      if (r) {
        console.log(r)
        this.reloadData()
        this.clear()
        this.preedit = null
      }
    },
    clear () {
      this.pre = {
        內場: [],
        外場: [],
        內場PT: [],
        外場PT: []
      }
    },
    addstaff () {
      if (this.preedit === 'pre') {
        const p = JSON.parse(JSON.stringify(this.pre[this.preedit2]))
        p.push(...this.preSelected)
        this.pre[this.preedit2] = Array.from(new Set(p))
        this.preSelected = []
        this.preedit2 = null
      } else {
        const p = JSON.parse(JSON.stringify(this.current.attendance[this.preedit][this.preedit2]))
        p.push(...this.preSelected)
        this.current.attendance[this.preedit][this.preedit2] = Array.from(new Set(p))
        this.preSelected = []
        this.preedit2 = null
      }
    },
    async reloadData () {
      const index = this.moment(this.day).diff(this.moment(this.start), 'day')
      const data = await this.getAvailables(this.moment(this.start).add(index, 'day'))
      this.days.splice(index, 1, data)
    },
    async setDays () {
      this.days = [
        await this.getAvailables(this.moment(this.start)),
        await this.getAvailables(this.moment(this.start).add(1, 'day')),
        await this.getAvailables(this.moment(this.start).add(2, 'day')),
        await this.getAvailables(this.moment(this.start).add(3, 'day')),
        await this.getAvailables(this.moment(this.start).add(4, 'day')),
        await this.getAvailables(this.moment(this.start).add(5, 'day')),
        await this.getAvailables(this.moment(this.start).add(6, 'day'))
      ]
    },
    async getAvailables (day) {
      const isHoliday = this.holidays.includes(this.toDate(day))
      const isWeekend = this.moment(day).weekday() === 0 || this.moment(day).weekday() === 6 || this.moment(day).weekday() === 7
      const availables = await getapi('restaurant/available2?' + new URLSearchParams({
        store: this.store,
        date: this.moment(day).startOf('day').toISOString(),
        isHoliday: isHoliday || isWeekend
      }))
      return availables
    },
    async getHoliday () {
      const holidays = await getapi('holidays')
      this.holidays = holidays.map(e => this.moment(e.date).format('YYYY-MM-DD'))
    },
    addWeek (num) {
      this.start = this.moment(this.start).add(num, 'week')
    }
  }
}
</script>
<style lang="scss">
.restaurantAttendance {
  .sub {
    .dialogbox > div:not(.headerBox) {
      padding-inline: 40px;
      box-sizing: border-box;
      padding-bottom: 26px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding-block: 21px;
      overflow-x: hidden;
      width: 100%;
    }
  }
  .pre {
    .dialogbox > div:not(.headerBox) {
      max-height: 700px;
      overflow-y: auto;
      margin-block: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding-block: 21px;
      overflow-x: hidden;
      gap: 0;
    }
  }
  .dialogbox > div:not(.headerBox) > div {
    margin: 0;
    padding: 0;
    gap: 0;
  }
  .dialogbox > div > .empsbox {
    margin: 0!important;
    padding: 0!important;
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.liststaff {
  padding: 11px 19px;
  display: flex;
  flex-wrap: wrap;
  gap: 18px 15px;
  align-content: flex-start;
}
.liststaff>div {
  width: 140px;
  height: 40px;
  background: #E5E5E5;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 18px 12px;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #848484;
  button {
    width: 25px;
    height: 25px;
    border: none;
    background-color: #848484;
    mask: center / contain no-repeat url(./close_round.svg);
  }
}
.empsbox {
  display: grid;
  grid-template-columns: repeat(3, 180px);
  gap: 25px 35px!important;

}
label.checkbox {
  width: 180px;
  height: 49px;
  border: 1px solid var(--color-checked);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  gap: 10px;
}
input[type=checkbox] {
  width: 30px;
  height: 30px;
  accent-color: var(--color-checked);
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid var(--color-checked);
  }
}
select {
  width: 300px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  border-radius: 3px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  margin-left: 0;
  margin-right: auto;
}
.btns {
  display: flex!important;
  align-items: center;
  justify-content: center;
  gap: 28px;
  button {
    width: 100px;
    height: 35px;
    background: #B8B8B8;
    border-radius: 20px;
    border: none;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
}
.addbtn {
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background-color: var(--color-checked);
  background-position: center;
  background-size: 18px;
  background-repeat: no-repeat;
  background-image: url(./add.svg);
  border: none;
}
.day-preedit {
  padding: 0px;
  gap: 20px;
  width: 100%;
}

.day-preedit>div {
    width: 100%;
    min-height: 125px;
    display: grid;
    grid-template-rows: 25px 125px;
    gap: 6px;
    padding: 15px 10px;
    &>div {
      &:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 400;
        font-size: 18px;
        letter-spacing: 0.1em;
        color: var(--color-checked);
      }
      &:nth-child(2) {
        border: 1px solid #CACACA;
        border-radius: 5px;
        overflow-y: auto;
        min-height: 125px;
      }
    }
}
.day-edit-li {
  margin-top: 16px;
  width: 1040px;
  padding-right: 14px;
  overflow-y: scroll;
  padding: 5px;
  height: calc(100% - 90px);
  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--color-checked);
  }
  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 20px;
    background-color: #d8d8d8;
    border: 2px solid #FFFFFF!important;
  }
}
.day-edit-li>div {
  width: 1006px;
  height: 345px;
  min-height: 345px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  margin-block: 35px;
  display: grid;
  grid-template-columns: 90px repeat(4, 185px);
  overflow: hidden;
  gap: 40px;
  &:nth-child(1) {
    margin-top: 0;
  }
  &>div:nth-child(1) {
    background-color: var(--color-checked);
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 20px;
    line-height: 39px;
    letter-spacing: 0.1em;
  }
  &>div:not(:first-child) {
    width: 185px;
    display: grid;
    grid-template-rows: 25px 280px;
    padding-block: 14px 20px;
    gap: 6px;
    &>div {
      width: 100%;
      height: 100%;
      &:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 400;
        font-size: 18px;
        letter-spacing: 0.1em;
        color: var(--color-checked);
      }
      &:nth-child(2) {
        border: 1px solid #CACACA;
        border-radius: 5px;
        overflow-y: auto;
        max-height: 280px;
      }
    }
  }
}
.day-edit-top {
  width: 1030px;
  padding-right: 23px;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 25px;
  height: 35px;
  gap: 28px;
  button {
    width: 100px;
    height: 35px;
    background: #B8B8B8;
    border-radius: 20px;
    border: none;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
}
.day-num-summary {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  font-weight: 700;
  font-size: 24px;
  text-align: end;
  letter-spacing: 0.1em;
  color: #E37878;
  &::before {
    content: attr(label);
    font-size: 20px;
    font-weight: 400;
    letter-spacing: 0.1em;
    color: #848484;
    width: 71px;
    display: inline-flex;
  }
}
.day-content-li {
  width: 700px;
  height: 94px;
  background-color: #FFFFFF;
  display: grid;
  grid-template-columns: 80px repeat(4, 128px);
  padding-inline: 28px;
  gap: 20px;
  &:nth-child(odd) {
    background-color: var(--color-infobox);
  }
  &>div:nth-child(1) {
    width: 80px;
    height: 62px;
    background: var(--color-checked);
    border-radius: 5px;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    align-self: center;
    margin-inline: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
.day-content-top {
  width: 700px;
  height: 45px;
  background: var(--color-checked);
  font-weight: 700;
  font-size: 20px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  position: relative;
  &>button {
    position: absolute;
    width: 88px;
    height: 30px;
    background: #FFFFFF;
    border-radius: 5px;
    right: 11px;
    border: none;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    &::before {
      content: '';
      display: inline-flex;
      width: 16px;
      height: 16px;
      background-color: var(--color-checked);
      mask: center / contain no-repeat url(./pen.svg)

    }
  }
}
.day-content {
  width: 700px;
  border: none;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
  margin-bottom: 20px;
}
.num-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  padding-inline: 19px;
  &>div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    color: var(--color-checked);
    font-weight: 700;
    font-size: 18px;
    letter-spacing: 0.1em;
  }
  &>div::before {
    content: attr(label);
    font-size: 14px;
    letter-spacing: 0.1em;
    color: #848484;
    font-weight: 400;
  }
}
.weekcelender-content {
  margin-top: 27px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 700px;
  border-radius: 5px;
  min-height: 257px;
  overflow: hidden;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  &>div {
    border-right: 1px solid #CACACA;
    &:last-child {
      border-right: none;
    }
  }
  &>div>div:nth-child(1) {
    background-color: var(--color-checked);
    color: #FFFFFF;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &>div>div:nth-child(2) {
    color: var(--color-checked);
    height: 74px;
    border-bottom: 1px solid #CACACA;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.1em;
    &>div:nth-child(2) {
      color: var(--color-number);
      font-weight: 900;
      font-size: 18px;
    }
  }
  &>div>div:nth-child(3) {
    color: var(--color-checked);
    height: 148px;
  }
  &>.current {
    background-color: var(--color-infobox);
  }
}
.weekcelender-top {
  margin-top: 29px;
  width: 700px;
  height: 27px;
  min-height: 27px;
  font-weight: 500;
  font-size: 24px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  button {
    width: 11px;
    height: 25px;
    padding: 0;
    background-color: transparent;
    border: none;
  }
}
.content {
  display: grid;
  grid-template-columns: 767px 1083px;
  gap: 1px;
  grid-template-rows: calc(100vh - 90px);
  background-color: #CACACA;
  &>div{
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: calc(100vh - 90px);
    max-height: calc(100vh - 90px);
    overflow-y: auto;
    position: relative;
  }
}
.restaurantAttendance {

}
.title {
  margin-inline: 20px;
  background-color: #FFF;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &::before {
    content: '';
    display: inline-flex;
    width: 55px;
    height: 55px;
    mask-image: url(./setting.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: var(--color-checked);
  }
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-checked);
  gap: 10px;
}

.title > input[type=radio] {
  width: 120px;
  height: 40px;
  appearance: none;
  background-color: var(--color-border);
  color: #FFFFFF;
  border-radius: 3px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);  }

  &:checked {
    background-color: var(--color-checked);
  }

}
</style>
